import type { LiveEvent, Page, PageableInfoNew } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { formatLiveEventCardWithPrice } from '~/entities/live-events/events'
import { genPagesLogicNew } from '~/shared/effector'

export const resetPurchasedLiveEventsRow = createEvent()
export const $purchasedLiveEventsRow = createStore<Page<LiveEvent> | null>(null)
  .on(api.liveEvents.getPurchasedLiveEventsRowFx.doneData, (_, page) => page)
  .reset(resetPurchasedLiveEventsRow)

export const $purchasedLiveEventsRowFormatted = combine(
  $purchasedLiveEventsRow,
  i18n.$t,
  (purchasedLiveEventsRow) => ({
    ...purchasedLiveEventsRow,
    content: purchasedLiveEventsRow?.content.map(formatLiveEventCardWithPrice),
  })
)

export const resetPurchasedLiveEventsGrid = createEvent()
export const $purchasedLiveEventsGrid = createStore<Page<LiveEvent> | null>(
  null
)
  .on(api.liveEvents.getPurchasedLiveEventsGridFx.doneData, (state, page) => {
    const currentLiveEvents = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentLiveEvents,
    }
  })
  .reset(resetPurchasedLiveEventsGrid)

export const $purchasedLiveEventsGridFormatted = combine(
  $purchasedLiveEventsGrid,
  i18n.$t,
  (purchasedLiveEventsGrid) => {
    const formattedPageContent = purchasedLiveEventsGrid?.content.map(
      formatLiveEventCardWithPrice
    )

    return {
      ...purchasedLiveEventsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMorePurchasedLiveEventsGrid = genPagesLogicNew(
  $purchasedLiveEventsGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.liveEvents.getPurchasedLiveEventsGridFx
)
